import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription,
} from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import { waitlistAPI } from '@/lib/api';

export default function ComingSoonBilling() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleNotify = async (e) => {
    e.preventDefault();
    if (!email) return;

    try {
    setLoading(true);

    await waitlistAPI.add(email);

    toast.success('We will notify you when subscriptions are available');
    setEmail('');
    } catch (err) {
    toast.error('Failed to save email');
    } finally {
    setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
      <Card className="w-full max-w-md shadow-md">
        <CardHeader className="text-center space-y-2">
          <CardTitle className="text-2xl font-semibold">
            Subscriptions coming soon 🚀
          </CardTitle>
          <CardDescription>
            Paid plans are not available yet. You can start using ImportDocs
            for free or leave your email to be notified.
          </CardDescription>
        </CardHeader>

        <CardContent>
          {/* Free plan CTA */}
          <div className="space-y-4 mb-6">
            <Button
              className="w-full bg-importdocs-primary hover:bg-importdocs-primary-dark"
              onClick={() => navigate('/dashboard')}
            >
              Start with Free plan
            </Button>

            <p className="text-xs text-center text-importdocs-text-muted">
              No credit card required. Upgrade anytime.
            </p>

            <div className="relative text-center">
              <span className="bg-white px-2 text-xs text-importdocs-text-muted">
                or
              </span>
              <div className="absolute left-0 right-0 top-1/2 border-t border-slate-200 -z-10" />
            </div>
          </div>

          {/* Notify form */}
          <form onSubmit={handleNotify} className="space-y-4">
            <div className="space-y-1">
              <Label>Email address</Label>
              <Input
                type="email"
                placeholder="you@company.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <Button
              type="submit"
              variant="outline"
              className="w-full"
              disabled={loading}
            >
              {loading ? 'Saving...' : 'Notify me'}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
